<template>
  <div
    class="mobile-lite-block"
  >
    <slot name="content" />
  </div>
</template>
<script>
import { defineComponent, ref } from '@vue/composition-api';

const name = 'mobile-lite-block';
export default defineComponent({
  name,
  props: {
  },
  setup() {
  }
});
</script>
<style lang="scss" scoped>
.mobile-lite-block {
  margin: 16px 16px 0px 16px;
  border-radius: 4px;
  background-color: #fff;
  padding-bottom: 32px;
}
</style>
